import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import InstanceItemORv4 from './InstanceItemORv4';

const mapStateToProps = (state) => ({
  isORv4Admin: userSelectors.isORv4Admin(state),
});

export default connect(mapStateToProps, null)(InstanceItemORv4);
